import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { RoutesApp } from '../constants/Routes.constants';
import { TelemetryAdminService } from '../telemetry/telemetry-admin.service';

/**
 * Deja pasar a `#/telemetry` a un superadmin, con su propia sesión o entrando como otro usuario.
 *
 * No mira el rol del navegador: entrando como un cliente el rol es el del cliente, y lo único que
 * delata al superadmin es la marca firmada en el token, que solo el backend sabe validar. Por eso
 * pregunta a `canViewTelemetry`. Tampoco es la autorización —cada endpoint la vuelve a decidir—:
 * solo evita enseñar una vista que el backend va a rechazar.
 */
@Injectable({
    providedIn: 'root'
})
export class TelemetryViewerGuard {
    constructor (private router: Router, private telemetry: TelemetryAdminService) {}

    async canActivate (): Promise<boolean | UrlTree> {
        if ((await this.telemetry.access()).allowed) return true;
        return this.router.parseUrl(RoutesApp.Shipment.Drayage.List);
    }
}
